import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { t } from '../utils/i18n';

const REASON_PREVIEW_LEN = 140;

/**
 * Truncated recommendation reason with expand toggle.
 */
function RecommendationReason({ reason, language }) {
  const [expanded, setExpanded] = useState(false);
  if (!reason) return null;

  const needsTruncate = reason.length > REASON_PREVIEW_LEN;
  const displayText =
    needsTruncate && !expanded ? `${reason.slice(0, REASON_PREVIEW_LEN).trim()}…` : reason;

  return (
    <div className="mb-2">
      <small className="text-primary d-block mb-1 fw-semibold" style={{ fontSize: '0.75rem' }}>
        {t('recommendations.whyRecommended', language)}
      </small>
      <small className="text-muted d-block recommendation-reason-text">
        {displayText}
      </small>
      {needsTruncate && (
        <Button
          variant="link"
          size="sm"
          className="p-0 mt-1 recommendation-reason-toggle"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded
            ? t('recommendations.readLess', language)
            : t('recommendations.readMore', language)}
        </Button>
      )}
    </div>
  );
}

export default RecommendationReason;
